export class DateService {
    private static STORAGE_KEY = 'simulated_date_override';

    /**
     * Get the current application date.
     * If a simulated date lies in localStorage, returns that date.
     * Otherwise returns new Date().
     */
    static now(): Date {
        const simulatedDateStr = localStorage.getItem(this.STORAGE_KEY);
        if (simulatedDateStr) {
            const simulatedDate = new Date(simulatedDateStr);
            if (isNaN(simulatedDate.getTime())) return new Date();

            // Create a mixed date: simulated Year/Month/Day + current Hour/Minute/Second
            // This ensures we don't get stuck at midnight when testing
            const now = new Date();
            return new Date(
                simulatedDate.getFullYear(),
                simulatedDate.getMonth(),
                simulatedDate.getDate(),
                now.getHours(),
                now.getMinutes(),
                now.getSeconds(),
                now.getMilliseconds()
            );
        }
        return new Date();
    }

    /**
     * Set a simulated date.
     * @param date Date object or ISO string. Pass null to reset to real time.
     */
    static setSimulatedDate(date: Date | string | null): void {
        if (date === null) {
            localStorage.removeItem(this.STORAGE_KEY);
        } else {
            const d = new Date(date);
            // set to noon to avoid timezone edge cases?
            // or just store ISO string
            localStorage.setItem(this.STORAGE_KEY, d.toISOString());
        }
        // Force reload to apply changes across app
        window.location.reload();
    }

    /**
     * Get the simulated date string if active, otherwise null
     */
    static getSimulatedDate(): string | null {
        return localStorage.getItem(this.STORAGE_KEY);
    }
}
